import styled from 'src/style';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

export const StyledExternalLink = styled.a({
  height: '65px',
  width: '75%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: '5px',
  backgroundColor: colors.purple,
  color: colors.white,
  fontSize: 19,
  lineHeight: '28px',
  fontWeight: 'bold',
  textDecoration: 'none',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: 5,
  overflow: 'hidden',
  boxShadow: 'rgba(0, 0, 0, 0.2) 0px 2px 4px',
  transitionProperty: 'all',
  transitionDuration: '0.3s',
  outlineStyle: 'none',
  transitionTimingFunction: 'ease-in-out',
  '&:before': {
    content: '""',
    position: 'absolute',
    display: 'block',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    transform: 'scaleX(0)',
    transformOrigin: '0 50%',
    transitionProperty: 'transform',
    transitionDuration: '0.3s',
    transitionTimingFunction: 'ease-in-out',
    backgroundColor: 'rgba(255,255,255, 0.1)',
  },
  '&:hover:before': {
    transform: 'scaleX(1)',
  },
  '&:hover': {
    transform: 'translateY(1px)',
  },
  [mediaQueries.phoneOnly]: {
    height: '75px',
    width: '100%',
    fontSize: 18,
    lineHeight: '25px',
  },
});
